module.exports = __webpack_public_path__ + "static/media/chanel-n-5-big.c04614cb.png";